import { FC } from "react"
import If from "../../if"
import { BBColumnDef, Channel } from "../../../../types"
import NameCell from "./cells/name"
import CplCell from "./cells/cpl"
import StatusCell from "./cells/status"
import ActionsCell from "./cells/actions"
import Table from "../../table"

interface Props {
  data: Channel[]
  isFetching: boolean
  onSelect: (val: string) => void
  isAdmin: boolean
}

const ChannelsTab: FC<Props> = ({ data, isFetching, onSelect, isAdmin }) => {
  const baseColumns: BBColumnDef<Channel>[] = [
    {
      id: "name",
      header: "Name",
      accessorFn: row => row.name,
      footer: props => props.column.id,
      cell: props => (
        <td className="py-4 px-4 align-middle">
          <NameCell
            info={props.row.original}
            onSelect={isAdmin ? onSelect : undefined}
          />
        </td>
      )
    },
    {
      id: "cpl",
      header: "CPL",
      accessorFn: row => row.cpl_dollars,
      footer: props => props.column.id,
      cell: props => (
        <td className="py-4 px-4 align-middle">
          <CplCell info={props.row.original} />
        </td>
      )
    },
    {
      id: "status",
      header: "Status",
      accessorFn: row => row.status,
      footer: props => props.column.id,
      cell: props => (
        <td className="py-4 px-4 align-middle">
          <StatusCell info={props.row.original} />
        </td>
      )
    },
    {
      id: "created",
      header: "Created",
      accessorFn: row => row.created,
      footer: props => props.column.id,
      cell: props => {
        const timestamp = parseInt(props.row.original.created, 10)
        const date = new Date(timestamp * 1000)
        return (
          <td className="py-4 px-4 align-middle text-sm text-gray-600">
            {date.toLocaleDateString()}
          </td>
        )
      }
    }
  ]

  const columns: BBColumnDef<Channel>[] = isAdmin
    ? [
        ...baseColumns,
        {
          id: "actions",
          header: "Actions",
          accessorFn: row => row.id,
          footer: props => props.column.id,
          meta: {
            headerClassName: "text-right pr-6"
          },
          cell: props => (
            <td className="py-4 pl-4 pr-6 align-middle text-right">
              <ActionsCell info={props.row.original} onSelect={onSelect} />
            </td>
          )
        }
      ]
    : baseColumns

  return (
    <div>
      <If
        condition={!data?.length && !isFetching}
        then={
          <div className="text-center py-8 text-gray-500">
            {isAdmin
              ? 'No channels found. Click "Add New Channel" to create your first channel.'
              : "No channels configured for this organization."}
          </div>
        }
        else={
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <Table
              isLoading={isFetching}
              data={data}
              columns={columns}
              viewType="table"
              shrinkFilterSort
              searchBarVisible={false}
              defaultSortBy="created"
              defaultSortDir="desc"
              tableClassName="table-auto"
              tableHeaderClassName="py-3 pl-5 pr-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide"
              dividedRows={false}
            />
          </div>
        }
      />
    </div>
  )
}

export default ChannelsTab
